import style from './express-workouts-home-section.module.scss'
import { ExpressWorkoutHomeCardList } from '../express-workout-home-card-list/express-workout-home-card-list'
import { ExpressWorkoutHomeCardListSkeleton } from '../express-workout-home-card-list/express-workout-home-card-list-skeleton'
import { ForwardArrowLink } from '../forward-arrow-link/forward-arrow-link'
import { Container, Row } from 'react-bootstrap'
import { SectionTitle } from 'src/component/ui/section-title'
import { useTrendingExpressWorkouts } from 'src/hook/use-workouts'

export const ExpressWorkouts = (): React.ReactElement => {
  const { data: workouts = [], isLoading } = useTrendingExpressWorkouts()

  // `.length`, not `!workouts`: `= []` above means `workouts` is never falsy, so the
  // original guard could not fire and an empty list fell through to
  // `ExpressWorkoutHomeCardList`, whose `workouts[0]` is then `undefined` — a
  // "Cannot read properties of undefined (reading 'id')" error boundary over the whole
  // of Home. Same shape as `FeaturedWorkoutsSection` and `LetsGetMoving`: an empty
  // section renders nothing at all.
  // `?? []` as well as the default above: the destructuring default only covers
  // `undefined`, and React Query hands back `null` on some error paths.
  if (!isLoading && (workouts ?? []).length === 0) return <></>

  return (
    <Container className={style.ExpressWorkoutsContainer}>
      <Row className="flex flex-nowrap justify-between items-center gap-4">
        <SectionTitle>Trending Express Workouts</SectionTitle>
        <div className="flex-shrink-0">
          <ForwardArrowLink text="See All" link="/workouts-preset/trending_express" theme="light" />
        </div>
      </Row>
      {isLoading ? <ExpressWorkoutHomeCardListSkeleton /> : <ExpressWorkoutHomeCardList workouts={workouts} />}
    </Container>
  )
}
